import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { first } from 'rxjs/operators';
import { CurBaseService } from './firebase/curbase.service';
import { GlobalService } from './global.service';
import { OappService } from './oapp.service';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	version?: string;
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false;
	collapseUserSidebar: boolean = true;
	public org: any;

	constructor(private curBaseService: CurBaseService, private oapp: OappService, private globalS:GlobalService) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
		globalS.getData().subscribe(data=>{
			if(data.empresa){
				this.org=data.empresa
				this.getMenuItems( oapp.solonetsolin)
			}
		})
		
	}

	async getMenuItems(solonetsolin) {
		const link = `/empresas/${this.org.id_reg}/menuItems`
		const items = await this.curBaseService.getCollectionFB(link).pipe(first()).toPromise();
		console.log(items)
		items.sort((a, b) => a['order'] - b['order'])
		console.log(items)
		console.log(solonetsolin)
		// this.MENUITEMS = this.MENUITEMS.concat(items)
		this.MENUITEMS=[]

		if (!solonetsolin) {
			this.MENUITEMS = this.MENUITEMS.concat([
				{
					title: 'Mi Conjunto', icon: 'home', type: 'link', badgeType: 'primary', active: true, path: '/dashboard', version: '2'
				},
				{
					title: 'Unidades', icon: 'square', type: 'link', badgeType: 'primary', active: true, path: '/up', version: '2'
				},
				{
					title: 'Residentes', icon: 'users', type: 'link', badgeType: 'primary', active: true, path: '/personas', version: '2'
				},
				{
					title: 'Bienes Comunes', icon: 'map-pin', type: 'link', badgeType: 'primary', active: true, path: '/bc', version: '2'
				},
				{
					title: 'Presupuesto', icon: 'dollar-sign', type: 'link', badgeType: 'primary', active: true, path: '/cartera', version: '2'
				},
			]);
		}
		// if(this.oapp.car){

		this.MENUITEMS = this.MENUITEMS.concat([
				{
					title: 'Home', icon: 'home', type: 'link', badgeType: 'primary', active: true, path: '/erp', version: '2'
				},
				{
					title: 'Doc. Contable', icon: 'slack', type: 'link', badgeType: 'primary', active: false, path: '/doccontabil/VPARWMOVIMIENC/0/A/B/0', version: '2'
				},
				{
					title: 'Doc. Soporte.', icon: 'slack', type: 'link', badgeType: 'primary', active: false, path: '/docsoporte/VPARDOCSOPOR_C/0/A/B/0', version: '1'
				},
				{
					title: 'Cuentas', icon: 'dollar-sign', type: 'link', badgeType: 'primary', active: false, path: '1/Cuentas', version: '3'
				},
				{
					title: 'Monitor Terceros', icon: 'dollar-sign', type: 'link', badgeType: 'primary', active: false, path: 'monitortercero/VPARTERCEROS/1023969960', version: '1'
				},
				{
					title: 'Monitor Cuentas', icon: 'dollar-sign', type: 'link', badgeType: 'primary', active: false, path: 'moncuentas/VPARCUENTAS/41701001', version: '3'
				},
				{
					title: 'Administracion', icon: 'box', type: 'link', badgeType: 'primary', active: false, path: 'menuadmin', version: '3'
				},
				{
					title: 'GridCustom', icon: 'box', type: 'link', badgeType: 'primary', active: false, path: 'manobjbasifb/gridcustom', version: '3'
				},
			])
		// }
		this.items.next(this.MENUITEMS);
	}

	addMenuItems() {
		const link = '/empresas/VS5XoPnemBQIdncptgPF/menuItems'
		const menu = {

			title: 'Starter Kit', icon: 'anchor', type: 'sub', badgeType: 'primary', active: true, order: 1, children:
				[
					{
						title: 'Color Version', type: 'sub', active: true, children: [
							{ path: '/color-version/light', title: 'Layout Light', type: 'link' },
							{ path: '/color-version/dark', title: 'Layout Dark', type: 'link' }
						]
					},
					{
						title: 'Sidebar', type: 'sub', active: false, children: [
							{ path: '/sidebar/light-sidebar', title: 'Light Sidebar', type: 'link' },
							{ path: '/sidebar/compact-sidebar', title: 'Compact Sidebar', type: 'link', bookmark: true },
							{ path: '/sidebar/icon-sidebar', title: 'Compact Icon Sidebar', type: 'link' },
							{ path: '/sidebar/dark-sidebar', title: 'Dark Sidebar', type: 'link' },
							{ path: '/sidebar/hidden-sidebar', title: 'Sidebar Hidden', type: 'link', bookmark: true },
							{ path: '/sidebar/fixed-sidebar', title: 'Sidebar Fixed', type: 'link' },
							{ path: '/sidebar/image-sidebar', title: 'Sidebar With Image', type: 'link' },
							{ path: '/sidebar/disable', title: 'Disable', type: 'link', bookmark: true },
						]
					},
					{
						title: 'Page Layout', type: 'sub', active: false, children: [
							{ path: '/page-layout/boxed', title: 'Boxed', type: 'link', bookmark: true },
							{ path: '/page-layout/rtl', title: 'RTL', type: 'link', bookmark: true },
							{ path: '/page-layout/column', title: '1 Column', type: 'link' },
						]
					},
					{
						title: 'Menu Options', type: 'sub', active: false, children: [
							{ path: '/menu-option/scroll', title: 'Hide menu on Scroll', type: 'link' },
							{ path: '/menu-option/vertical', title: 'Vertical Menu', type: 'link' },
							{ path: '/menu-option/mega', title: 'Mega Menu', type: 'link', bookmark: true },
							{ path: '/menu-option/fix-header', title: 'Fix Header', type: 'link' },
							{ path: '/menu-option/header', title: 'Fix Header & Sidebar', type: 'link' },
						]
					},
					{
						title: 'Footers', type: 'sub', active: false, children: [
							{ path: '/footer/light-footer', title: 'Footer Light', type: 'link', bookmark: true },
							{ path: '/footer/dark-footer', title: 'Footer Dark', type: 'link' },
							{ path: '/footer/fixed-footer', title: 'Footer Fixed', type: 'link' },
						]
					}, {
						title: 'Mant. Objetos Firebase', icon: 'box', type: 'link', badgeType: 'primary', active: true, path: 'menuobjbasfb'
					},
					{
						title: 'Administracion', icon: 'box', type: 'link', badgeType: 'primary', active: true, path: 'menuadmin'
					},
				]
		}
		console.log('menu', menu)
		this.curBaseService.addDocSinIdFb(link, menu)
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		// {
		// 	title: 'Test Link', icon: 'anchor', type: 'extLink', badgeType: 'primary', path: 'http://google.com'
		// },
		// {
		// 	title: 'Test Link tab', icon: 'anchor', type: 'extTabLink', badgeType: 'primary', path: 'http://www.google.com'
		// }
	]
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
